"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.function.bind");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(Object(source)); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * these props will be added to the wrapped component
 * We assume these props do not conflict with props of the
 * wrapped component
 */
var propTypes = {
  // id is required for a11y support, but we generate one
  // if not provided.  Warning: generating an id causes a
  // re-render on client-side
  id: _propTypes.string.isRequired,

  /**
   * These props are uncontrolled by default.
   * This HoC will handle them automatically, but you
   * can set them as well on the wrapped component as needed.
   */
  // gets/sets expanded region status
  expanded: _propTypes.bool,
  // outer component can be notified of expansion changes
  onExpandableToggle: _propTypes.func,

  /**
   * This prop is uncontrollable, meaning this HoC generates it.
   * See the render function for usage
   */
  // eslint-disable-next-line react/forbid-prop-types
  expandable: _propTypes.object
};
var defaultProps = {
  expanded: false,
  expandable: {},
  onExpandableToggle: function onExpandableToggle() {}
};
/**
 * Enhances a component with expandable behavior-handling for a
 * expandable region and triggers
 * @param  {Component} ComponentToEnhance Component to enhance
 * @return {Component} enhanced component
 */

var expandable = function expandable(ComponentToEnhance) {
  var WithExpandable =
  /*#__PURE__*/
  function (_Component) {
    _inherits(WithExpandable, _Component);

    function WithExpandable(props) {
      var _this;

      _classCallCheck(this, WithExpandable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(WithExpandable).call(this, props));
      var expanded = props.expanded;
      _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
      _this.handleExpand = _this.handleExpand.bind(_assertThisInitialized(_this));
      _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
      _this.state = {
        // tracks expanded/collapsed status
        expanded: expanded,
        // primer for a expandable region id
        id: null
      };
      return _this;
    }

    _createClass(WithExpandable, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this$props$id = this.props.id,
            id = _this$props$id === void 0 ? (0, _uniqueId["default"])() : _this$props$id; // ensure expandable will have an ID so triggers can control it

        this.setState({
          id: "".concat(id || (0, _uniqueId["default"])('with-expandable'), "__expandable")
        });
      }
      /** allow expanded state to optionally be controlled */

    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var currentProp = this.props.expanded;
        var nextProp = nextProps.expanded;
        var expanded = this.state.expanded;
        var shouldUpdate = currentProp !== nextProp && nextProp !== expanded;

        if (shouldUpdate) {
          this.setState({
            expanded: expanded
          });
        }
      }
      /** handles expand/collapse of region */

    }, {
      key: "handleToggle",
      value: function handleToggle(e) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var onExpandableToggle = this.props.onExpandableToggle;
        var currentlyExpanded = this.state.expanded;
        var expanded = force !== null ? force : !currentlyExpanded; // alert any listeners on the component

        onExpandableToggle(e, {
          expanded: expanded
        }); // halt from update if action was prevented

        if (e && e.defaultPrevented) {
          return;
        }

        this.setState({
          expanded: expanded
        });
      }
    }, {
      key: "handleExpand",
      value: function handleExpand(e) {
        this.handleToggle(e, true);
      }
    }, {
      key: "handleCollapse",
      value: function handleCollapse(e) {
        this.handleToggle(e, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            expanded = _this$state.expanded,
            id = _this$state.id; // spread these onto an expandable container
        // e.g. <div {...props.expandable.region} />

        var region = {
          'aria-expanded': expanded.toString(),
          id: id,
          role: 'region',
          tabIndex: -1
        }; // spread these onto a button that should toggle
        // the container
        // e.g. <button {...props.expandable.toggle} />

        var toggle = {
          'aria-controls': id,
          'aria-expanded': expanded.toString(),
          role: 'button',
          onClick: this.handleToggle,
          tabIndex: 0
        }; // use these as needed for custom control
        // e.g. (
        //   <div
        //     onMouseEnter={props.expandable.actions.expand}
        //     onMouseLeave={props.expandable.actions.collapse}
        //   >
        //    ...
        //   </div>

        var actions = {
          collapse: this.handleCollapse,
          expand: this.handleExpand,
          toggle: this.handleToggle
        };
        return _react["default"].createElement(ComponentToEnhance, _extends({}, this.props, {
          expanded: expanded,
          expandable: {
            region: region,
            toggle: toggle,
            actions: actions
          }
        }));
      }
    }]);

    return WithExpandable;
  }(_react.Component);

  var getDisplayName = function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  };

  WithExpandable.displayName = "WithExpandable(".concat(getDisplayName(ComponentToEnhance), ")");
  WithExpandable.propTypes = _objectSpread({}, ComponentToEnhance.propTypes, propTypes);
  WithExpandable.defaultProps = _objectSpread({}, ComponentToEnhance.defaultProps, defaultProps);
  return WithExpandable;
};

expandable.propTypes = propTypes;
expandable.defaultProps = defaultProps;
var _default = expandable;
exports["default"] = _default;